import * as React from 'react';
import Slider from 'react-slick';
import {ImageOptions} from 'components/UIKit/Picture';
import {ListingImage} from '../ListingImage/ListingImage';
import {ShopScreenShot} from '../../../../types';
import styles from './ImageSwiper.scss';

export interface ImageSwiperProps {
  images: ShopScreenShot[];
  altPrefix?: string;
}

export interface ImageSwiperState {
  selected: number;
}

const fullImageOptions: ImageOptions[] = [
  {
    breakpoint: {
      min: null,
      max: 750,
    },
    options: {
      format: 'jpg',
      width: 345,
      height: 223,
    },
  },
];

export class ImageSwiper extends React.PureComponent<ImageSwiperProps, ImageSwiperState> {
  constructor(props) {
    super(props);

    this.state = {
      selected: 0,
    };
  }

  handleIndexChange = (index) => {
    this.setState({selected: index});
  };

  render() {
    const {selected} = this.state;
    const {images, altPrefix} = this.props;

    return (
      <>
        <Slider dots infinite className="listing-swipe" slidesToShow={1} slidesToScroll={1}>
          {images.map((image, index) => (
            <ListingImage
              id={image.id}
              key={image.id}
              alt={`${altPrefix} - ${index + 1}`}
              type="default"
              imageUrl={image.url}
              imageOptions={fullImageOptions}
              wrapperComponent="div"
            />
          ))}
        </Slider>
        <span className={styles.index}>{`${selected + 1}/${images.length}`}</span>
      </>
    );
  }
}
